<template>
  <div
    class="flex flex-col items-center pt-10 desktop:pt-[60px] px-4 pb-3 w-full"
  >
    <BackButton
      v-if="!webviewStore.isActive && !isPricingFirstCheckout"
      class="fixed left-3 top-[3px] desktop:top-2 z-50"
      @click="handleBackClick"
    />

    <div class="w-full max-w-[480px] flex flex-col flex-grow">
      <div
        class="mb-[30px] text-[24px] font-medium leading-[28px] text-gray-800"
      >
        {{ selectedPlan?.name || 'Checkout' }}
      </div>

      <CheckoutSummary
        :selected-plan="selectedPlan"
        :selected-plan-item="selectedPlanItem"
        :selected-billing-cycle="selectedBillingCycle"
        :has-more-than-one-price="hasMoreThanOnePrice"
        :get-billing-cycle-price="getBillingCyclePrice"
        :format-upsell-text="formatUpsellText"
        :registrations-estimate="registrationsEstimate"
        :awaiting-estimate="awaitingEstimate"
        :hide-change="isPricingFirstCheckout"
        @change="handleChangeClick"
        @upgrade="handleUpgradeClick"
      />

      <CheckoutPaymentForm
        :payment-method="paymentMethod"
        :card-classes="cardClasses"
        :accept-terms="acceptTerms"
        :loading="loading"
        :awaiting-estimate="awaitingEstimate"
        :error-message="errorMessage"
        :selected-plan-item="selectedPlanItem"
        :selected-billing-cycle="selectedBillingCycle"
        :has-more-than-one-price="hasMoreThanOnePrice"
        :get-billing-cycle-price="getBillingCyclePrice"
        @update:accept-terms="acceptTerms = $event"
        @update-payment-method="handleUpdatePaymentMethod"
        @purchase="handlePurchase"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import BackButton from '@/shared/components/BackButton.vue'
import CheckoutSummary from '@/features/billing/components/CheckoutSummary.vue'
import CheckoutPaymentForm from '@/features/billing/components/CheckoutPaymentForm.vue'
import { useCheckout } from '@/features/billing/composables/useCheckout'
import { useWebviewStore } from '@/shared/stores/webview'

const webviewStore = useWebviewStore()

const {
  acceptTerms,
  loading,
  errorMessage,
  selectedPlan,
  selectedPlanItem,
  selectedBillingCycle,
  getBillingCyclePrice,
  hasMoreThanOnePrice,
  cardClasses,
  paymentMethod,
  registrationsEstimate,
  awaitingEstimate,
  isPricingFirstCheckout,
  handleChangeClick,
  handleBackClick,
  formatUpsellText,
  handleUpdatePaymentMethod,
  handleUpgradeClick,
  handlePurchase,
} = useCheckout()
</script>
